// defaultPermissions.js
import { PERMISSIONS } from "./permissions";

const nonAdminGeneral = Object.values(PERMISSIONS.GENERAL).filter(
  p => p !== PERMISSIONS.GENERAL.VIEW_KOHO
);

const nonAdminReports = Object.values(PERMISSIONS.REPORTS).filter(
  p => p !== PERMISSIONS.REPORTS.AI_GENERATE && p !== PERMISSIONS.REPORTS.MANAGE_TEXT_RECOMMENDATIONS
);

export const DEFAULT_ROLE_PERMISSIONS = {
  admin: [
    ...Object.values(PERMISSIONS.GENERAL),
    ...Object.values(PERMISSIONS.REPORTS),
    ...Object.values(PERMISSIONS.TALOYHTIOKORTTI),
    ...Object.values(PERMISSIONS.KEHITYSLISTA),
  ],

vieras: [
  PERMISSIONS.GENERAL.VIEW_TALOYHTIOKORTIT,
  PERMISSIONS.REPORTS.ASSIGN_REPORT_MAKER,
],

  tyontekija: [
    ...nonAdminGeneral,
    ...nonAdminReports,
    ...Object.values(PERMISSIONS.TALOYHTIOKORTTI),
  
  ],

  myyjä: [
    ...nonAdminGeneral,
    ...nonAdminReports,
    ...Object.values(PERMISSIONS.TALOYHTIOKORTTI),
  ],

  lvi: [
    ...nonAdminGeneral,
    ...nonAdminReports,
    ...Object.values(PERMISSIONS.TALOYHTIOKORTTI),
  ],

  sähkö: [
    ...nonAdminGeneral,
    ...nonAdminReports,
    ...Object.values(PERMISSIONS.TALOYHTIOKORTTI),
  ],

  rakennetekniikka: [
    ...nonAdminGeneral,
    ...nonAdminReports,
    ...Object.values(PERMISSIONS.TALOYHTIOKORTTI),
  ],
};
